/**
 * @generated SignedSource<<f0963519a2abb7984a0a0f4fb54a0ee5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InputCharacteristicResponseMultiSelect_characteristic$data = {
  readonly answers: ReadonlyArray<{
    readonly id: string;
    readonly text: string;
    readonly userSpecified: boolean;
  }>;
  readonly id: string;
  readonly " $fragmentType": "InputCharacteristicResponseMultiSelect_characteristic";
};
export type InputCharacteristicResponseMultiSelect_characteristic$key = {
  readonly " $data"?: InputCharacteristicResponseMultiSelect_characteristic$data;
  readonly " $fragmentSpreads": FragmentRefs<"InputCharacteristicResponseMultiSelect_characteristic">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InputCharacteristicResponseMultiSelect_characteristic",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CharacteristicAnswerNode",
      "kind": "LinkedField",
      "name": "answers",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userSpecified",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CharacteristicNode",
  "abstractKey": null
};
})();

(node as any).hash = "b2284cae35ae609ea3526139707649d2";

export default node;
